import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '~/environments/environment';
import {TrackingService} from '@services/tracking.service';

export interface EmpruntResult {
    today_debt_rate: number;
    future_debt_rate: number;
    optim_sucess: boolean;
    borrowing_capacity: number;
    loan_monthly_payement: number;
    future_location_revenus: number;
    revenus_for_bank: number;
    charges_for_bank: number;
    errorMessage?: string;
}

@Component({
    selector: 'app-config-emprunt-tools',
    templateUrl: './config-emprunt-tools.component.html'
})
export class ConfigEmpruntToolsComponent {

    // Mêmes champs (et mêmes valeurs par défaut) que le simulateur du site : lambda simu_emprunt
    form = {
        salary: null,
        today_rental_revenues: null,
        other_incomes: null,
        today_loan_monthly_payement: null,
        personnal_rent: null,
        other_expenses: null,
        gross_return: null,
        loan_maturity: 20,
        loan_rate: 4.0,
    };

    loading = false;
    result: EmpruntResult = null;
    status: '' | 'success' | 'debt' | 'fail' | 'error' = '';

    constructor(
        private http: HttpClient,
        public trackingService: TrackingService) {
    }

    simulate() {
        if (this.loading) {
            return;
        }

        const data = {
            salary: this.toNumber(this.form.salary),
            today_rental_revenues: this.toNumber(this.form.today_rental_revenues),
            other_incomes: this.toNumber(this.form.other_incomes),
            today_loan_monthly_payement: this.toNumber(this.form.today_loan_monthly_payement),
            personnal_rent: this.toNumber(this.form.personnal_rent),
            other_expenses: this.toNumber(this.form.other_expenses),
            gross_return: this.toNumber(this.form.gross_return) / 100,
            loan_maturity: this.toNumber(this.form.loan_maturity),
            loan_rate: this.toNumber(this.form.loan_rate) / 100,
        };

        this.loading = true;
        this.trackingService.click('tool_emprunt_simulate', '');
        this.http.post<EmpruntResult>(environment.empruntUrl, data).subscribe(result => {
            this.loading = false;
            this.result = result;
            if (result.errorMessage !== undefined) {
                this.status = 'error';
            } else if (result.today_debt_rate > 0.35) {
                this.status = 'debt';
            } else if (result.future_debt_rate <= 0.35 && result.optim_sucess == true) {
                this.status = 'success';
            } else {
                this.status = 'fail';
            }
        }, () => {
            this.loading = false;
            this.result = null;
            this.status = 'error';
        });
    }

    private toNumber(value: any): number {
        const number = parseFloat(String(value ?? '').replace(',', '.').replace(/\s/g, ''));
        return isNaN(number) ? 0 : number;
    }
}
